import { useState } from 'react';
import { api } from '../../api';
import ConfigListManager from '../../components/ConfigListManager';

export function CombinedConfigPage() {
  const [tab, setTab] = useState('call_types');
  return (
    <div style={{ padding: '24px' }}>
      <div className="setup-tabs" style={{ marginBottom: '20px' }}>
        <button className={`setup-tab ${tab === 'call_types' ? 'active' : ''}`} onClick={() => setTab('call_types')}>Call Types</button>
        <button className={`setup-tab ${tab === 'call_reasons' ? 'active' : ''}`} onClick={() => setTab('call_reasons')}>Call Reasons</button>
        <button className={`setup-tab ${tab === 'resolutions' ? 'active' : ''}`} onClick={() => setTab('resolutions')}>Resolutions</button>
        <button className={`setup-tab ${tab === 'vsf' ? 'active' : ''}`} onClick={() => setTab('vsf')}>VSF Locations</button>
      </div>
      {tab === 'call_types' && <CallTypesPage />}
      {tab === 'call_reasons' && <CallReasonsPage />}
      {tab === 'resolutions' && <ResolutionReasonsPage />}
      {tab === 'vsf' && <VsfInlineSection />}
    </div>
  );
}

function VsfInlineSection() {
  return (
    <ConfigListManager
      title="VSF Locations"
      fetchFn={api.getVsfLocations}
      createFn={api.createVsfLocation}
      updateFn={api.updateVsfLocation}
      deleteFn={api.deleteVsfLocation}
      extraFields={[
        { key: 'address', label: 'Address', type: 'text', defaultValue: '' },
        { key: 'city', label: 'City', type: 'text', defaultValue: '' },
        { key: 'state', label: 'State', type: 'text', defaultValue: 'TX' },
      ]}
    />
  );
}

export function CallTypesPage() {
  return (
    <ConfigListManager
      title="Call Types"
      fetchFn={api.getCallTypes}
      createFn={api.createCallType}
      updateFn={api.updateCallType}
      deleteFn={api.deleteCallType}
      extraFields={[{
        key: 'mode',
        label: 'Mode',
        type: 'select',
        options: [
          { value: 'standard', label: 'Standard' },
          { value: 'courtesy', label: 'Courtesy (Pickup/Dropoff)' },
          { value: 'location', label: 'Location (Custom/Scheduled)' },
          { value: 'takeback', label: 'Take Back (VSF → Destination)' },
        ],
        defaultValue: 'standard'
      }, {
        key: 'allowed_roles',
        label: 'Allowed Roles',
        type: 'multiselect',
        options: [
          { value: 'super_admin', label: 'Super Admin' },
          { value: 'admin', label: 'Admin' },
          { value: 'dispatcher', label: 'Dispatcher' },
          { value: 'sales', label: 'Sales' },
          { value: 'driver', label: 'Driver' },
        ],
        defaultValue: ''
      }]}
    />
  );
}

export function CallReasonsPage() {
  return (
    <ConfigListManager
      title="Call Reasons"
      fetchFn={api.getCallReasons}
      createFn={api.createCallReason}
      updateFn={api.updateCallReason}
      deleteFn={api.deleteCallReason}
    />
  );
}

export function ResolutionReasonsPage() {
  return (
    <ConfigListManager
      title="Resolution Reasons"
      fetchFn={api.getResolutionReasons}
      createFn={api.createResolutionReason}
      updateFn={api.updateResolutionReason}
      deleteFn={api.deleteResolutionReason}
    />
  );
}
